<aeg-datatable :value="pagedInvoices.items" sortField="documentDate" :sortOrder="-1" :loading="isLoading">
    <template #empty>
        U heeft nog geen facturen of betalingsbewijzen.
    </template>
    <template #footer>
        <div class="flex justify-between items-center">
            <Button
                v-if="showDownloadLink"
                as="a"
                icon="pi pi-download"
                iconPos="left"
                variant="link"
                :href="downloadFileUri"
                label="Download"
            />
            <aeg-paginator
                :paging-info="pagedInvoices.pagingInfo"
                @change-page="changePage"
            />
        </div>
    </template>
    <Column header="Datum" :field="(invoice) => formatDate(invoice.submitTimestamp)"
            :sortable="true" body-style="width: 8em;" />
    <Column field="invoiceNumber" header="Doc. nr." />
    <Column field="service" header="Service" body-class="aeg-uppercase"></Column>
    <Column field="actorName" header="Crediteur"></Column>
    <Column header="Type" :field="(invoice) => getDocumentTypeLabel(invoice.submitTimestamp)" />
    <Column body-style="text-align: center; width: 2em;">
        <template #body="slotProps">
            <i :class="getInvoiceTypeIcon(slotProps?.data?.documentType)" style="font-size: 1.125rem;"/>
        </template>
    </Column>
    <Column field="totalPrice" header="Bedrag" header-style="direction: rtl; text-align: justify; width: 7em;"
            body-style="text-align: right;">
        <template #body="slotProps">
                  <span :class="{'aeg-invoices-details__topup': slotProps?.data?.isTopUpCredit }">
                      {{
                          slotProps?.data?.isTopUpCredit ? `+&nbsp${formatCurrency(slotProps?.data?.totalPrice)}` : formatCurrency(slotProps?.data?.totalPrice)
                      }}
                  </span>
        </template>
    </Column>
    <Column header="Betaald" body-style="text-align: center; width: 7em;"
            :pt="{ columnHeaderContent: { class: 'justify-center' }}">
        <template #body="slotProps">
            <check-icon v-if="slotProps?.data?.paid" style="font-size: 1.125rem;"/>
        </template>
    </Column>
    <Column header="PDF" body-style="text-align: center; padding:0; width: 3em;"
            :pt="{ columnHeaderContent: { class: 'justify-center' }}">
        <template #body="slotProps">
            <Button
                v-if="slotProps?.data?.directPdfUrl"
                as="a"
                variant="link"
                icon="pi pi-file-pdf"
                --label="PDF"
                aria-label="Download als pdf"
                :href="slotProps?.data?.directPdfUrl"
                size="large"
                style="padding:0;"
            /><!-- Wouter: workaround for default button padding blowing up the table row height + needs tooltip -->
        </template>
    </Column>
    <Column header="CSV" body-style="text-align: center; center; padding:0; width: 3em;"
            :pt="{ columnHeaderContent: { class: 'justify-center' }}">
        <template #body="slotProps">
            <Button
                v-if="slotProps?.data?.directCsvUrl"
                as="a"
                variant="link"
                icon="pi pi-file-excel"
                --label="CSV"
                aria-label="Download als csv"
                :href="slotProps?.data?.directCsvUrl"
                size="large"
                style="padding:0;"
            />
        </template>
    </Column>
</aeg-datatable>
